"use client"

import { ReactNode } from "react"
import { AuthProvider } from "@/lib/auth/auth-provider"
import { AuthGuard } from "@/components/auth/auth-guard"

/**
 * Combines the auth context with route-level guarding (see `main.tsx`).
 */
export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <AuthProvider>
      <AuthGuard>{children}</AuthGuard>
    </AuthProvider>
  )
}
